import React, { useEffect, useState } from "react";
import { useNavigate } from "react-router-dom";
import { Alert, Button, Modal, notification } from "antd";
import { FiArrowLeft, FiEdit2, FiPlus } from "react-icons/fi";
import config from "../../config";
import serviceAvatar from "../../services/avatar";
import { removeStorageWhenLogout } from "../../config/helper";

const ModalAvatarList = ({
	activeAvatar,
	openModal,
	onClose = () => {},
	onAddAvatar = () => {},
	onEditAvatar = () => {},
	onEmptyAvatar = () => {},
	onSwapAvatar = () => {},
	profileResponse,
}) => {
	const navigate = useNavigate();

	const [alertMessage, setAlertMessage] = useState(null);
	const [theAvatars, setTheAvatars] = useState([]);

	const handleGetAvatars = async () => {
		const response = await serviceAvatar.getAvatars();

		if (response.httpStatus === 401) {
			notification.error({ message: "Unauthorize!" });
			removeStorageWhenLogout();
			setTimeout(() => {
				navigate("/signin");
			}, config.timeout);
		}
		if (response.httpStatus === 200) {
			if (profileResponse.httpStatus !== 404) {
				if (response.data.length === 0) {
					onEmptyAvatar({
						avatarShow: true,
						popupShow: false,
					});
				} else {
					setTheAvatars(response.data);
				}
			}
		}
	};

	const handleOnCloseModal = () => {
		if (!activeAvatar) {
			setAlertMessage("You need to choose AI avatar.");
			return;
		}
		onClose({
			avatarShow: false,
			popupShow: true,
		});
	};

	useEffect(() => {
		handleGetAvatars();
	}, []);

	return (
		<Modal
			footer={null}
			className="profile-modal"
			open={openModal}
			onCancel={handleOnCloseModal}
			destroyOnClose
		>
			<div className="top-section">
				<div className="user-profile">
					<Button
						className="user-profile-icon"
						icon={<FiArrowLeft size={24} />}
						onClick={handleOnCloseModal}
					/>
					Choose/Change Avatar
				</div>
				{alertMessage && (
					<Alert
						closable
						message={alertMessage}
						type="error"
						onClose={() => setAlertMessage(null)}
					/>
				)}
				<div className="avatar-list">
					<div className="avatar-item">
						<Button
							className="avatar-item-add"
							icon={<FiPlus size={32} />}
							onClick={() =>
								onAddAvatar({
									avatarAddShow: true,
									avatarShow: false,
								})
							}
						/>
					</div>
					{theAvatars.map((avatar) => {
						return (
							<div
								className={
									activeAvatar === avatar.id
										? "avatar-item active"
										: "avatar-item"
								}
								key={avatar.id}
							>
								<div className="avatar-buddy-wrapper">
									<img
										src={avatar.aIsrc}
										alt="Avatar"
										onClick={() => onSwapAvatar(avatar.id)}
										style={{ cursor: "pointer" }}
									/>
									<div className="buddy-name">
										<span>{avatar.aIname}</span>
										<Button
											icon={<FiEdit2 size={10} />}
											onClick={() =>
												onEditAvatar(avatar.id)
											}
											style={{
												width: "20px",
												height: "20px",
												marginLeft: "10px",
												padding: 0,
												border: 0,
											}}
										/>
									</div>
								</div>
							</div>
						);
					})}
				</div>
			</div>
		</Modal>
	);
};

export default ModalAvatarList;
